
const validate = (props) => {
    const errors = {}

    if (!props.email) {
        errors.email = {
            ar: 'يرجى ادخال البريد الالكتروني',
            en: 'Enter your email'
        }
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(props.email)) {
        errors.email = {
            ar: 'البريد الالكتروني غير صحيح',
            en: 'invalid email'
        }
    }
    if (!props.type) {
        errors.type = {
            ar: ' يرجى اختيار النوع  ',
            en: 'Please choose type'
        }
    } 

    return errors
}

export default validate;